import { FeePackageState } from "@/admin/types";
import { FetchState } from "@/shared/types";
import _ from "lodash";
import { defineStore } from "pinia";
import * as cardService from "@/shared/api/cardService";
import * as storeHelper from "@/shared/storeHelper";

export const initialState: FeePackageState = {
  feePackages: [],
  fetchState: FetchState.Uninitialized
};

export const useFeePackageStore = defineStore("feePackage", {
  state: () => (_.cloneDeep(initialState)),
  actions: {
    loadFeePackages () {
      if (this.fetchState !== FetchState.Uninitialized) {
        return;
      }

      this.fetchState = FetchState.Loading;

      cardService.listFeePackages()
        .then(response => {
          this.feePackages = response.data.feePackages;
          this.fetchState = FetchState.Loaded;
        })
        .catch(error => {
          this.fetchState = FetchState.Uninitialized;
          storeHelper.handleError({ error, rethrow: true });
        });
    }
  }
});
